<div class="min-vh-100">
  <app-candidat-header></app-candidat-header>
  <!-- PDF client §5 : connexion autorisée avant validation, avec un accès limité (pas de candidature). -->
  <div class="pending-validation-banner" *ngIf="pendingValidation" role="status">
    <strong>Votre compte est en attente de validation par l'équipe.</strong>
    Vous pouvez compléter votre profil et renseigner vos disponibilités ; vous pourrez postuler aux missions dès la validation.
  </div>
  <div class="candidat-container">
    <router-outlet></router-outlet>

  </div>
</div>
<ng-container *ngIf="isChatActive">
  <button class="floating-chat-button" (click)="toggleChat()" [title]="totalUnreadCount > 0 ? totalUnreadCount + ' message(s) non lu(s)' : 'Ouvrir la messagerie'">
    <svg-icon src="assets/icons/send-white.svg"></svg-icon>
    <span class="chat-badge" *ngIf="totalUnreadCount > 0">{{ totalUnreadCount }}</span>
  </button>
  <app-chat-popup *ngIf="isChatOpen" (closeChat)="toggleChat()"></app-chat-popup>
</ng-container>
